export const BASE_URL = process.env.NODE_ENV === 'development' ? 'http://localhost:8000' : 'https://app.anjalavsar.com';

export const MAIN_SITE_HOST = process.env.NODE_ENV === 'development' ? 'localhost:3000' : 'anjalavsar.com';

export const RAJKOT_SITE_HOST = 'rajkot.anjalavsar.com';
export const AMD_SITE_HOST = 'ahmedabad.anjalavsar.com';
export const SURAT_SITE_HOST = 'surat.anjalavsar.com';
export const LOHANA_SITE_HOST = 'lohana.anjalavsar.com';
export const DIVORCEE_SITE_HOST = 'divorcee.anjalavsar.com';
export const NRI_SITE_HOST = 'nri.anjalavsar.com';
export const JAIN_SITE_HOST = 'jain.anjalavsar.com';
export const KOLKATA_SITE_HOST = 'kolkata.anjalavsar.com';
export const GORMAHARAJ_HOST = 'gormaharaj.anjalavsar.com';
export const SHAADIYOG_HOST = 'shaadiyog.in';


export const SITES = [
  [MAIN_SITE_HOST, 'Anjal ane Avsar'],
  [RAJKOT_SITE_HOST, 'Anjal ane Avsar Rajkot'],
  [AMD_SITE_HOST, 'Anjal ane Avsar Ahmedabad'],
  [SURAT_SITE_HOST, 'Anjal ane Avsar Surat'],
  [LOHANA_SITE_HOST, 'Anjal ane Avsar Lohana'],
  [DIVORCEE_SITE_HOST, 'Anjal ane Avsar Divorcee'],
  [NRI_SITE_HOST, 'Anjal ane Avsar NRI'],
  [JAIN_SITE_HOST, 'Anjal ane Avsar Jain'],
  [KOLKATA_SITE_HOST, 'Anjal ane Avsar Kolkata'],
  [SHAADIYOG_HOST, 'Shaadi Yog'],
];


export const OLD_LOGIN_DISABLED = [
  SHAADIYOG_HOST,
];

export const FB_APP_ID = process.env.NODE_ENV === 'development' ? '188069108483423' : '710783099631354';

export const GOOGLE_APP_ID = process.env.NODE_ENV === 'development' ? '955966245801-42joo6fd3rlm7cj1dm6vior3ujmhe98d.apps.googleusercontent.com' : '759850579140-ivv6v960l816ovtuafafr9gmroi97pop.apps.googleusercontent.com';

export const SECTION_STEPS = {
  basicinfo: 'step-1',
  personalinfo: 'step-2',
  lifestyleinfo: 'step-3',
  educationinfo: 'step-4',
  familyinfo: 'step-5',
  contactinfo: 'step-6',
  referenceinfo: 'step-7',
  photos: 'step-8',
  pdfs: 'step-9',
};

export const COMPLETE_PROFILE_TITLES = {
  'step-1': 'Step 1 of 9 - Account Information',
  'step-2': 'Step 2 of 9 - Personal Profile',
  'step-3': 'Step 3 of 9 - Your Lifestyle',
  'step-4': 'Step 4 of 9 - Education & Work',
  'step-5': 'Step 5 of 9 - Family Info',
  'step-6': 'Step 6 of 9 - Contact Info',
  'step-7': 'Step 7 of 9 - Reference Info',
  'step-8': 'Step 8 of 9 - Upload Photos',
  'step-9': 'Step 9 of 9 - Upload Bio Data',
};


export const STEP_SECTIONS = {
  'step-1': 'basicinfo',
  'step-2': 'personalinfo',
  'step-3': 'lifestyleinfo',
  'step-4': 'educationinfo',
  'step-5': 'familyinfo',
  'step-6': 'contactinfo',
  'step-7': 'referenceinfo',
  'step-8': 'photos',
  'step-9': 'pdfs',
};


export const SECTION_TITLES = {
  basicinfo: 'Account Information',
  personalinfo: 'Edit Personal Info',
  lifestyleinfo: 'Your Lifestyle',
  educationinfo: 'Education & Work',
  familyinfo: 'Family Info',
  contactinfo: 'Contact Info',
  referenceinfo: 'Reference Info',
  photos: 'Upload Photos',
  pdfs: 'Upload Bio Data',
  partnerchoice: 'Partner\'s Choice',
};


export const SEARCH_FILTERS = {
  from_age: 'From age',
  to_age: 'To age',
  from_height: 'From height',
  to_height: 'To height',
  marital_status: 'Marital Status',
  profession: 'Profession',
  work_profile: 'Work Profile',
  caste: 'Caste',
  qualification: 'Qualification',
  study_field: 'Study Field',
  degree: 'Degree',
  income: 'Income',
  from_india: 'Candidates Living in India?',
  country: 'Country',
  city: 'Country',
  bureau: 'Bureau',
  is_premium: 'Show Gor Maharaj (premium) profiles',
};


export const CSS_FILES = {
  'localhost:3000': null,
  'anjalavsar.com': null,
};


export const LOGO_FILES = {
  'localhost:3000': 'main.png',
  'anjalavsar.com': 'main.png',
};


export const COVER_FILES = {
  'localhost:3000': 'back2.jpg',
  'anjalavsar.com': 'back2.jpg',
};


export const DEFAULT_ERROR = 'Something went wrong! Please reload your page. If it still does not work, then please contact at support@anjalavsar.com';



// WEBPACK FOOTER //
// ./src/config/constants.js